import styled from "styled-components";

export const StyledDocUploadWrapper = styled.div`
  border: 1px solid #ebebeb;
  padding: 2.4rem;
  background-color: #fafafa;
  border-radius: 5px;
`;
export const StyledDocUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  text-align: center;
`;
export const StyledDocUploadPreviewWrapper = styled.div`
  padding: 1.6rem;
  background-color: #fafafa;
  border-radius: 5px;
`;
export const StyledDocUploadPreviewContainer = styled.div`
  border: 1px solid #d9d9d9;
  padding: 8px;
  border-radius: 5px;
`;
export const StyledDocUploadVideoWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
export const StyledDocUploadVideo = styled.video`
  max-width: 376px;
  width: 100%;
`;
export const StyledDocUploadRiveWrapper = styled.div`
  max-width: 33rem;
  width: 100%;
  height: 37.264rem;

  @media (min-width: 430px) {
    max-width: 35.3rem;
    height: 39.882rem;
  }
  @media (min-width: 768px) {
    max-width: 37.6rem;
    height: 42.5rem;
  }
`;
export const StyledKycStatusRiveWrapper = styled.div`
  max-width: 28.4rem;
  width: 100%;
  height: 18.5rem;

  @media (min-width: 430px) {
    max-width: 32rem;
    height: 22.5rem;
  }
  @media (min-width: 768px) {
    max-width: 37.6rem;
    height: 26.5rem;
  }
`;
